import * as PaymentTimeLimit from './PaymentTimeLimit.css';
import * as PaymentTimeLimitPage from '../PaymentTimeLimitPage/PaymentTimeLimitPage.css';

export default {
	PaymentTimeLimit,
	PaymentTimeLimitPage
};
